// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {Checkbox} from 'cap-it-ui.toggles';
import {FormattedMessage} from 'react-intl';
import LabeledString from '../../../../../../shared/components/labeled-string';
import {viewFile} from '../../../../../../shared/services/file-view';

function onFileClick(file) {

    viewFile(file, true);

}
const AttachmentInfo = props =>
    <div className='rga-info'>
        <header>
            <Checkbox
                id={props.item.serialNumber}
                onChange={props.handleFileSelect}
                selected={props.initialState[props.item[props.uid]] || false}
            >{''}</Checkbox>
            <button
                className='button-text'
                onClick={onFileClick.bind(null, props.item)}
            >
                {props.item.fileName}
            </button>
        </header>
        <div className='row'>
            <LabeledString
                className='rolling-month-credit'
                data={props.item.source}
                label='File Format'
            />
        </div>
        <section className='button-group recalled-button-group'>
            <button
                className='secondary'
                onClick={onFileClick.bind(null, props.item)}
            >
                <FormattedMessage id='View'/>
            </button>
        </section>
    </div>;

AttachmentInfo.displayName = 'AttachmentInfo';
AttachmentInfo.propTypes = {
    handleFileSelect: PropTypes.func.isRequired,
    initialState: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    uid: PropTypes.string.isRequired
};

export default AttachmentInfo;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/returned-part-information/recalled-part-tab/components/attachment-info.js